// BulkSend.jsx
import React, { Component } from "react";
import { Row, Col, Form, Button, Card, Spinner, ProgressBar } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
const API_BASE = process.env.REACT_APP_API_BASE_URL;


export default class BulkSend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      imageUrl: "",          // <-- URL returned by the server after upload
      imagePreviewUrl: "",   // local preview (or use imageUrl after upload)
      uploading: false,
      uploadProgress: 0,
      sending: false,
    };

    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.clearImage = this.clearImage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  // endpoints (use REACT_APP_API_BASE_URL from .env)
  get uploadEndpoint() {
    const base = process.env.REACT_APP_API_BASE_URL || "";
    return `${base}/uploads/image`;
  }

  get sendEndpoint() {
    const base = process.env.REACT_APP_API_BASE_URL || "";
    return `${base}/messages/bulk`;
  }

  get maxImageSizeMB() {
    return this.props.maxImageSizeMB || 5; // 5 MB
  }

  handleTextChange(e) {
    this.setState({ text: e.target.value });
  }

  async handleImageChange(e) {
    const file = e.target.files?.[0] || null;
    if (!file) {
      this.setState({ imageUrl: "", imagePreviewUrl: "" });
      return;
    }

    // basic validations
    if (!file.type.startsWith("image/")) {
      toast.error("Внесете валидна слика (JPEG/PNG и сл.)");
      e.target.value = "";
      return;
    }
    const maxBytes = this.maxImageSizeMB * 1024 * 1024;
    if (file.size > maxBytes) {
      toast.error(`Сликата е поголема од ${this.maxImageSizeMB}MB`);
      e.target.value = "";
      return;
    }

    // optional local preview right away
    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({ imagePreviewUrl: reader.result });
    };
    reader.readAsDataURL(file);

    // NOW: upload immediately
    try {
      const token = Cookies.get("jwt");
      const fd = new FormData();
      fd.append("image", file); // field name "image" must match the backend

      this.setState({ uploading: true, uploadProgress: 0 });

      const { data } = await axios.post(this.uploadEndpoint, fd, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}`, },
        onUploadProgress: (pe) => {
          if (!pe.total) return;
          const percent = Math.round((pe.loaded * 100) / pe.total);
          this.setState({ uploadProgress: percent });
        },
      });

      if (!data?.url) {
        throw new Error("Нема враќање на URL од серверот.");
      }

      // Use the server URL going forward (this is what Viber needs)
      this.setState({
        imageUrl: data.url,
        // You can also show the server URL as preview (ensures it's publicly reachable)
        imagePreviewUrl: data.url,
        uploading: false,
        uploadProgress: 100,
      });

      toast.success("Сликата е успешно качена.");
    } catch (err) {
      console.error(err);
      this.setState({ uploading: false, uploadProgress: 0, imageUrl: "" });
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Настана грешка при качување на слика";
      toast.error(msg);
      // clear the file input so user can re-pick
      e.target.value = "";
    }
  }

  clearImage() {
    // (Optional) If you have a delete endpoint, call it here.
    this.setState({ imageUrl: "", imagePreviewUrl: "", uploadProgress: 0 });
  }

  async handleSubmit(e) {
    e.preventDefault();

    const { text, imageUrl, uploading } = this.state;

    if (uploading) {
      toast.info("Сликата се уште се качува. Почекајте да заврши.");
      return;
    }

    // You can change this rule. For now, allow sending if text or imageUrl exists.
    if (!text && !imageUrl) {
      toast.error("Внесете текст или изберете слика пред да испратите.");
      return;
    }

    try {
      const token = Cookies.get("jwt");
      this.setState({ sending: true });

      const payload = {
        text: text || "",
        imageUrl: imageUrl || "",
        messageId: this.props.messageId || "",
        answeredBy: this.props.answeredBy || "",
      };

      const res = await axios.post(this.sendEndpoint, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,   // 🔑 add token here
        },
      });

      toast.success("Успешно испратено!");
      this.setState({
        text: "",
        imageUrl: "",
        imagePreviewUrl: "",
        sending: false,
        uploadProgress: 0,
      });

      if (this.props.onSuccess) this.props.onSuccess(res.data);
    } catch (err) {
      console.error(err);
      this.setState({ sending: false });
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Настана грешка при испраќање";
      toast.error(msg);
      if (this.props.onError) this.props.onError(err);
    }

  }

  render() {
    const { text, imagePreviewUrl, uploading, uploadProgress, sending, imageUrl } =
      this.state;

    return (
      <Row className="mt-3">
        <ToastContainer />
        <Col lg={12}>
          <Card className="p-3">
            <Form onSubmit={this.handleSubmit}>
              {/* Text area */}
              <Form.Group controlId="msgText">
                <Form.Label>Текст</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Внесете порака..."
                  value={text}
                  onChange={this.handleTextChange}
                />
              </Form.Group>

              {/* Image upload (instant upload) */}
              <Form.Group controlId="imageUpload" className="mt-3">
                <Form.Label>Слика</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={this.handleImageChange}
                  disabled={uploading || sending}
                />

                {/* Upload progress */}
                {uploading && (
                  <div className="mt-2">
                    <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} />
                    <small className="text-muted">Качување...</small>
                  </div>
                )}

                {/* Preview */}
                {imagePreviewUrl ? (
                  <div className="mt-2">
                    <img
                      src={imagePreviewUrl}
                      alt="preview"
                      style={{ maxWidth: "300px", maxHeight: "200px" }}
                    />
                    <div className="d-flex align-items-center mt-2">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={this.clearImage}
                        disabled={uploading || sending}
                      >
                        Отстрани
                      </Button>
                      {imageUrl ? (
                        <small className="text-success ml-2">
                          Качено ✓
                        </small>
                      ) : null}
                    </div>
                  </div>
                ) : null}

                <small className="form-text text-muted">
                  Максимум {this.maxImageSizeMB}MB.
                </small>
              </Form.Group>

              {/* Send */}
              <div className="mt-4">
                <Button
                  type="submit"
                  className="button-standard"
                  disabled={sending || uploading}
                >
                  {sending ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="mr-2"
                      />
                      Се испраќа...
                    </>
                  ) : (
                    <>
                      <i className="material-icons mr-1">send</i>
                      Испрати
                    </>
                  )}
                </Button>
              </div>
            </Form>
          </Card>
        </Col>
      </Row>
    );
  }
}
